import * as coreEntities from 'core/store/index';
import { isTeacher } from 'core/utils/user';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function useGroups() {
  const dispatch = useDispatch();
  const user = useSelector((state) => coreEntities.auth.selectors.getUser(state));

  const groups = useSelector((state) => coreEntities.groups.selectors.getGroups(state));

  useEffect(() => {
    if (!groups) {
      getGroups();
    }
  }, [groups]);

  async function getGroups() {
    if (user && typeof user.schools != 'undefined' && isTeacher(user)) {
      if (user.schools.length > 0) {
        dispatch(
          coreEntities.groups.actions.getGroups({
            params: { offset: 0, pageSize: 1000, schoolGuid: user.schools[0].guid, members: 'teachers' },
          })
        );
        dispatch(coreEntities.schoolYears.actions.getSchoolYears({ params: { offset: 0, pageSize: 1000, schoolGuid: user.schools[0].guid } }));
      }
    }
  }

  return { groups };
}
